import { Expense } from "Models/expenses";
import BaseService from "./_base.service";
import { AxiosResponse } from "axios";
import API from "../api";

const endpoint = "expenses";

const ExpensesService = {
  ...BaseService<Expense>({ endpoint }),
  async autoCalculateExpensesBasedOnTimeSheet(data: { taskId: number }): Promise<AxiosResponse<any>> {
    return await API.post(`${endpoint}/auto-calculate-expenses-based-on-timesheet`, data);
  }
}

export default ExpensesService;
